import './DefaultCards.css';
import React from 'react';
import { get, getGlobalDictionaryTerm } from '../../../utils';
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink/RouterLink';
import LazyPicture from '../../atoms/LazyPicture';
import { tealiumMergeClickNewData, tealiumClickFunc } from '../../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { convertToAnalyticObject } from '../../../utils/analytics';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
var Card = function Card(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    _ref$inCarousel = _ref.inCarousel,
    inCarousel = _ref$inCarousel === void 0 ? false : _ref$inCarousel;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var fieldsData = get(fields, 'data');
  var item = get(fieldsData, 'item');
  var imageSrc = get(item, 'image.jss.value.src');
  var imageAlt = get(item, 'image.jss.value.alt');
  var hasTitle = get(item, 'title.jss');
  var hasTag = get(item, 'tag.jss.value');
  var tag = get(item, 'tag.jss');
  var hasDescription = get(item, 'description.jss');
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLink = get(item, 'ctaLink.jss.value.href');
  var cardTitle = get(item, 'title.jss.value');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderContentInLink = function renderContentInLink(children) {
    if (!ctaLink && !pageEditing) return children;
    var linkTitle = '';
    if (hasTitle && hasTitle.value) {
      linkTitle = hasTitle.value;
    } else {
      linkTitle = imageAlt ? imageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = "".concat(ctaLabel, " | ").concat(linkTitle);
    }
    if (item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === "_blank") {
      linkTitle = linkTitle ? "".concat(linkTitle, " | ").concat(newWindowLabel) : newWindowLabel;
    }
    return /*#__PURE__*/React.createElement(Link, {
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  var renderLink = function renderLink() {
    if (!ctaLabel || !item.ctaLink.jss.value.href) {
      return null;
    }
    if (pageEditing && item.ctaLink.jss.value.href) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "general-card-button",
      href: item.ctaLink.jss.value.href,
      title: ctaLabel,
      linktype: "external",
      openInSameTab: true,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['linkClickAnalytics'], params), [cardTitle, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel), ctaLabel && item.ctaLink.jss.value.href ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "card--item__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-box theme-contrast"
  }, imageSrc && renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
    }
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: "".concat(imageSrc, "&cw=500&ch=375")
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(imageSrc, "&cw=500&ch=375"),
    alt: imageAlt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-body"
  }, hasTag && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "b__title",
    field: tag
  }), hasTitle && hasTitle.value && hasTitle.value.trim() && renderContentInLink(/*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "h4 b__title-2",
    field: hasTitle,
    "data-cy": "general-card-image-title",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
    }
  })), hasDescription && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "body-large b__desc",
    field: hasDescription,
    "data-cy": "general-card-image-description"
  }), renderLink())));
};
var DefaultCards = function DefaultCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var title = get(fields, 'data.item.title.jss.value');
  var hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  var ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderButtonLink = function renderButtonLink() {
    return /*#__PURE__*/React.createElement("div", {
      className: "btnLink"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn",
      href: ctaLink,
      title: ctaLabel,
      openInSameTab: true,
      linktype: "external",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btnText"
    }, ctaLabel)));
  };
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "default-cards__item",
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: item.id
      }, /*#__PURE__*/React.createElement(Card, {
        fields: {
          data: {
            eventsAnalytics: eventsAnalytics,
            item: item
          }
        },
        params: params,
        inCarousel: true
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, items.length < 5 && (hasTitle || hasDescription) ? /*#__PURE__*/React.createElement("div", {
    className: "h__txt"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p componentDescription",
    field: fields.data.item.description.jss
  }) : null) : null, items.length < 5 ? /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems()) : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(hasTitle || hasDescription ? 'card__head' : 'cardHeadOnlyWithPagination')
    }, hasTitle || hasDescription ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "p componentDescription",
      field: fields.data.item.description.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNavAnalytics'], params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextNavAnalytics'], params));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1101
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1100,
            min: 900
          },
          items: 3
        },
        table_portrait: {
          breakpoint: {
            max: 899,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }, function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['mobileSlidesAnalytics'], params));
    })), ctaLink && ctaLabel && items.length >= 5 ? /*#__PURE__*/React.createElement("div", {
      className: "paginationAndLinkContainer"
    }, renderButtonLink(), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params));
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "paginationWithoutLinkContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params));
    }))));
  }) : null);
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    className = _ref4.className,
    style = _ref4.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonCardStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
export var commonCardStyles = "c1wxwe88";
var rtlStyles = "r828gkj";
var ltrStyles = "l1lvlvq9";
export { DefaultCards };